<mat-form-field class="textarea-form">
  <div class="label" translate>{{ label }}</div>
  <textarea
    class="textarea-form-control"
    matInput
    [formControl]="control"
    cdkTextareaAutosize
    cdkAutosizeMinRows="5"
    cdkAutosizeMaxRows="12"
    (blur)="onBlur()"
  ></textarea>
  <mat-error *ngIf="error">
    {{ error }}
  </mat-error>
</mat-form-field>
